module.exports = __webpack_public_path__ + "static/media/19PerformancePhotos.dc97f41f.jpeg";